export function getCurrentPageEntries(){
    if(!localStorage.getItem('VerificationListPageEntries')) {
        setCurrentPageEntries({rowsPerPage: 10, pageNumber: 0})
    }

    return JSON.parse(localStorage.getItem('VerificationListPageEntries'));
}

export function setCurrentPageEntries(pageParams){
    localStorage.setItem('VerificationListPageEntries', JSON.stringify(pageParams))
}

export function removeCurrentPageEntries(){
    localStorage.removeItem('VerificationListPageEntries')
}